<template>
  <v-container fluid class="mt-5">
    <v-row>
      <v-col cols="12" lg="10" md="10" sm="12">
        <filtri class="mb-3" @ricerca="onRicerca"/>
      </v-col>
    </v-row>
    <v-row justify="start" dense>
      <v-col cols="12" lg="5" md="5" sm="12">
        <v-card>
          <v-card-title>
            Elenco prodotti
          </v-card-title>
          <v-card-subtitle>
            Filtra e scegli i prodotti da mappare. Seleziona e aggiungi o doppio click sul singolo prodotto
          </v-card-subtitle>
          <v-card-text>
            <v-data-table
              v-model="selected"
              :show-select="totaleArticoli > 0"
              item-key="_id"
              :headers="headers"
              :items="articoliSorted"
              :options.sync="options"
              :server-items-length="totaleArticoli"
              :loading="loading"
              @dblclick:row="dblclickRow"
              class="elevation-1"
              :footer-props="{
                itemsPerPageOptions: [5, 10, 15, 50, 100]
              }"
              dense
            >
<!--               <template v-slot:top>
                <v-toolbar flat>
                </v-toolbar>
              </template> -->
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" lg="5" md="5" sm="12">
        <v-card>
          <v-card-title>
            <v-row no-gutters>
              <v-col>Elenco PLU</v-col>
              <v-spacer></v-spacer>
              <!-- <v-col cols="3"><v-switch v-model="mostraVuoti" class="mt-0" inset label="Mostra vuoti" title="Mostra anche gli eventuali PLU non compilati nell'intervallo visibile" @change="popolaPlu"></v-switch></v-col> -->
              <v-col cols="3"><v-select class="mr-5" v-model="defTipo" label="Tipo default" :items="tipiItem" dense hide-details></v-select></v-col>
              <v-col cols="2"><v-text-field v-model="basePlu" label="Visualizza dal Plu" type="number" dense hide-details reverse min="1" :max="maxPlu"></v-text-field></v-col>
            </v-row>
<!--             <span>Elenco PLU</span>
            <v-spacer></v-spacer>
            <span></span> -->
          </v-card-title>
          <v-card-subtitle>
            Elenco dei Plu trasferiti alla bilancia.
          </v-card-subtitle>
          <v-card-text>
            <v-data-table
              v-model="selectedPlu"
              :show-select="totalePlu > 0"
              item-key="codicePlu"
              :headers="headersPlu"
              :items="elencoPluBase"
              :options.sync="optionsPlu"
              :loading="loading"
              @dblclick:row="dblclickPluRow"
              class="elevation-1"
              :footer-props="{
                itemsPerPageOptions: [5, 10, 15, 50, 100]
              }"
              dense
            >           
              <template v-slot:[`item.tipo`]="{ item }">
                <v-edit-dialog
                  :return-value.sync="item.tipo"
                  large
                  persistent
                >
                  {{ item.tipo }}
                  <template v-slot:input>
                    <v-select class="mt-5 mb-5" v-model="item.tipo" label="Tipo" :items="tipiItem" dense hide-details></v-select>
                  </template>
                </v-edit-dialog>
              </template>            
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" lg="2" md="2" sm="12">
        <div class="text-center">
          <v-row no-gutters>
            <v-col>
              <v-btn class="" color="primary" @click="aggiungiSelezionati" :disabled="selected.length === 0" title="Aggiunge i prodotti selezionati nella lista dei PLU">Aggiungi selezionati</v-btn>
              <v-btn class="mt-5" color="default" @click="eliminaSelezionati" :disabled="selectedPlu.length === 0" title="Libera le posizioni selezionate della lista dei PLU">Elimina selezionati</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn class="mt-5" color="success" @click="salvaModifiche">Salva modifiche</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn class="mt-5 white--text" color="blue-grey" :loading="loadingGeneraFile" @click="generaFileBilancia" title="Genera il file per la configurazione della bilancia">Crea file bilancia</v-btn>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
    <!-- <v-btn class="mt-5" @click="salvaModifiche">Salva modifiche</v-btn> -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Confermi cancellazione ?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Annulla</v-btn>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>    
  </v-container>
</template>

<script>
  import _ from 'lodash'
  import Filtri from './filtriMappatura'
  import prodotti from '@/services/prodottiService'
  import bilance from '@/services/custom/bilanceService'
  import { downloadTxt, slugify } from '@/components/helpers'

  export default {
    components: {
      Filtri
    },
    props: {
      bilancia: Object
    },
    data: () => ({
      totaleArticoli: 0,
      articoli: [],
      selected: [],
      loading: true,
      options: { itemsPerPage: 50 },
      headers: [
        { text: 'Codice', value: 'codice', align: 'start' },
        { text: 'Descrizione', value: 'descrizione' }
      ],
      selectedPlu: [],
      elencoPlu: [],
      optionsPlu: { itemsPerPage: 50 },
      headersPlu: [
        { text: 'PLU', value: 'codicePlu', align: 'end' },
        { text: 'Prodotto', value: 'codiceProdotto', align: 'start' },
        { text: 'Descrizione', value: 'descrizione' },
        { text: 'Tipo', value: 'tipo' }
      ],
      filtri: {
        tipoItem: 'PRODOTTO',
        testo: '',
        marchio: [],
/*         variante1: [],
        variante2: [],
        stagione: [], */
        categoria1: [],
        categoria2: []
      },
      dialogDelete: false,
      editedIndex: -1,
      editedItem: null,
      basePlu: 1,
      // maxPlu: 300, // da impostazioni
      defTipo: 'peso',
      tipiItem: ['peso', 'confezione'],
      triggerAggiorna: 1,
      loadingGeneraFile: false,
      mostraVuoti: false
    }),
    created() {
    },
    async mounted() {
      await this.getDataFromApi()
      this.popolaPlu()
    },
    computed: {
      articoliSorted() {
        const els = this.triggerAggiorna && _.differenceBy(this.articoli, this.elencoPlu.filter(x => x._id), '_id')
        if (this.options.sortBy && this.options.sortBy.length > 0) {
          return els
        } else {
          const elSorted = _.sortBy(els, ['descrizione', 'varianti.variante2.descrizione', 'varianti.variante1.descrizione'])
          return elSorted
        }
      },
      totalePlu() {
        return this.elencoPluBase.length
      },
      elencoPluBase() {
        return this.elencoPlu.filter(x => x.codicePlu >= this.basePlu)
      },
      maxPlu() {
        return this.bilancia.maxPlu || 300
      },
      codiceBilancia() {
        return this.bilancia.codiceBilancia
      },
      pluBilancia() {
        return this.bilancia.plu
      },
      hft() {
        return this.bilancia.hft
      },
      listino() {
        return this.bilancia.listinoPrezzi || 'L1'
      },
      newLine() {
        return this.hft.newline || '\r\n'
      }
    },
    watch: {
      options: {
        async handler () {
          await this.getDataFromApi()
        },
        deep: true
      }
    },
    methods: {
      popolaPlu() {
        while(this.elencoPlu.length > 0) { this.elencoPlu.pop() }
        var plu
        for (let i = 0; i < this.maxPlu; i++) {
          // if (this.mostraVuoti) {
            plu = this.pluBilancia.find(x => x.codicePlu === i + 1)
          // } else {
          //   plu = this.pluBilancia[i]
          // }
          this.elencoPlu.push( plu || { codicePlu: i + 1, codiceProdotto: '', descrizione: '', tipo: '' }) 
        }
      },
      async onRicerca(filtri) {
        this.filtri = filtri
        this.filtri.tipoItem = 'PRODOTTO'
        await this.getDataFromApi()
      },
      async getDataFromApi () {
        try {
          this.loading = true
          const data = await prodotti.getFilteredProducts(this.filtri, this.options)
          
          const articoli = data && data.total_rows > 0 ? data.rows.map(x => x.doc) : []
          this.articoli = articoli.map(el => {
            el.allegati = el.allegati || []
            return { ...el }
          })
          this.totaleArticoli = data.total_rows
        } catch(err) {
          this.articoli = []
          this.totaleArticoli = 0
        } finally {
          this.loading = false
        }
      },
      salvaModifiche() {
        let dati = this.elencoPlu.filter(x => x.codiceProdotto).map(x => _.omit(x, '_id'))
        this.$emit('salva', this.codiceBilancia, dati)
      },
      deleteItem (item) {
        this.editedIndex = this.dati.orari.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },
      deleteItemConfirm () {
        this.dati.orari.splice(this.editedIndex, 1)
        this.closeDelete()
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = null
          this.editedIndex = -1
        })
      },
      dblclickRow(event, options) {
        const item = options.item
        this.editedIndex = this.articoli.indexOf(item)
        this.editedItem = Object.assign({}, item)
        if (!this.elencoPlu.find(x => x.codiceProdotto === item._id)) {
          let primoLibero = _.first(this.elencoPlu.filter(x => x.codiceProdotto === '' && x.codicePlu >= this.basePlu))
          primoLibero.codiceProdotto = item._id
          primoLibero.descrizione = item.descrizione
          primoLibero.tipo = this.defTipo
          primoLibero._id = item._id
          primoLibero.prezzoUnitario = _.get(item, `prezzo.${this.listino}.base`)
          this.triggerAggiorna++
        }
      },
      dblclickPluRow(event, options) {
        const item = options.item
        item.codiceProdotto = ''
        item.descrizione = ''
        item.tipo = ''
        item._id = ''
        item.prezzoUnitario = ''
        this.triggerAggiorna++
      },
      aggiungiSelezionati() {
        let base = this.basePlu
        if (this.selectedPlu.length > 0) {
          base = Math.max(base, this.selectedPlu[0].codicePlu)
        }
        for (let item of this.selected) {
          if (!this.elencoPlu.find(x => x.codiceProdotto === item._id)) {
            let primoLibero = _.first(this.elencoPlu.filter(x => x.codiceProdotto === '' && x.codicePlu >= base))
            primoLibero.codiceProdotto = item._id
            primoLibero.descrizione = item.descrizione
            primoLibero.tipo = this.defTipo
            primoLibero._id = item._id
            primoLibero.prezzoUnitario = _.get(item, `prezzo.${this.listino}.base`)
            this.triggerAggiorna++
          }
        }
        this.annullaSelezione()
      },
      eliminaSelezionati() {
        for (let item of this.selectedPlu) {
          item.codiceProdotto = ''
          item.descrizione = ''
          item.tipo = ''
          item._id = ''
          item.prezzoUnitario = ''
        }
        this.annullaSelezionePlu()
        this.triggerAggiorna++
      },
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      },
      annullaSelezionePlu() {
        while(this.selectedPlu.length > 0) { this.selectedPlu.pop() }
      },
      async generaFileBilancia() {
        this.loadingGeneraFile = true
        await this.aggiornaValoriPlu(this.bilancia)
        const elenco = await bilance.generaFileBilancia(this.bilancia)
        if (this.hft.tipoSalvataggio === 'download') {
          const nomeFile = this.hft.nomeFile || 'PLU.DAT'
          await downloadTxt(document, nomeFile, elenco.join(this.newLine))
        }
        this.loadingGeneraFile = false
      },
      async aggiornaValoriPlu(bilancia) {
        const ids = bilancia.plu.map(x => x.codiceProdotto)
        const elencoProdotti = await prodotti.getProdottiByIds(ids)
        const modificati = []
        for (let p of bilancia.plu) {
          const prodotto = elencoProdotti.find(x => x._id === p.codiceProdotto)
          if (prodotto) {
            if (p.descrizione !== prodotto.descrizione) {
              p.descrizione = prodotto.descrizione
              modificati.push(p)
            }
            if (!p.isReparto && p.prezzoUnitario !== _.get(prodotto, `prezzo.${this.listino}.base`)) {
              p.prezzoUnitario = _.get(prodotto, `prezzo.${this.listino}.base`)
              modificati.push(p)
            }      
          }
        }
        if (modificati.length > 0) {
          await this.salvaModifiche()
        }
      }      
    }
  }
</script>
